import React from 'react'
import { isNil } from 'lodash'

import { formatDateUk } from '../../../core/utils'

import { menuCurationTaskTimestampsPropType } from '../../prop-types'
import { StyledUpdatedText } from '../styled'

const MenuCurationTaskTimestamps = ({ timestamps }) => {
  const {
    autoeatUpdatedAt,
    autoeatUpdateAppliedAt,
    tierOneDoneAt,
    tierOneDoneBy,
    curatedAt,
    qadAt,
    qcdAt,
    curatedBy,
    qadBy,
    qcdBy,
    tierOneCuratorAssignedAt,
    unknownWordsCuratorAssignedAt,
    unknownWordsQaAssignedAt,
    curatorAssignedAt,
    lastManualUpdateAt,
    qaAssignedAt,
    qcAssignedAt,
    unknownWordsCuratedAt,
    unknownWordsQadAt,
    unknownWordsCuratedBy,
    unknownWordsQadBy,
    lastManualUpdateBy,
    latestTierOneDoneDishCount,
    latestCuratedDishCount,
    latestQadDishCount,
    latestQcdDishCount,
    latestCuratedUnknownWordCount,
    latestQadUnknownWordCount,
  } = timestamps
  return (
    <>
      <StyledUpdatedText>{`${formatDateUk(
        autoeatUpdatedAt,
      )} - Autoeat update received`}</StyledUpdatedText>

      {!isNil(autoeatUpdateAppliedAt) && (
        <StyledUpdatedText>{`${formatDateUk(
          autoeatUpdateAppliedAt,
        )} - Autoeat update applied`}</StyledUpdatedText>
      )}

      {!isNil(lastManualUpdateAt) && !isNil(lastManualUpdateBy) && (
        <StyledUpdatedText>{`${formatDateUk(lastManualUpdateAt)}${
          lastManualUpdateBy
            ? `- Last manual update  - ${lastManualUpdateBy.email}`
            : ''
        }`}</StyledUpdatedText>
      )}

      {!isNil(tierOneCuratorAssignedAt) && (
        <StyledUpdatedText>{`${formatDateUk(
          tierOneCuratorAssignedAt,
        )} - Tier One assigned`}</StyledUpdatedText>
      )}
      {!isNil(tierOneDoneAt) && !isNil(tierOneDoneBy) && (
        <StyledUpdatedText>{`${formatDateUk(tierOneDoneAt)}${
          tierOneDoneBy ? `- Tier One done - ${tierOneDoneBy.email}` : ''
        }(${latestTierOneDoneDishCount})`}</StyledUpdatedText>
      )}

      {!isNil(curatorAssignedAt) && (
        <StyledUpdatedText>{`${formatDateUk(
          curatorAssignedAt,
        )} - Curator assigned`}</StyledUpdatedText>
      )}
      {!isNil(curatedAt) && !isNil(curatedBy) && (
        <StyledUpdatedText>{`${formatDateUk(curatedAt)}${
          curatedBy ? `- Curation done - ${curatedBy.email}` : ''
        } (${latestCuratedDishCount})`}</StyledUpdatedText>
      )}

      {!isNil(qaAssignedAt) && (
        <StyledUpdatedText>{`${formatDateUk(
          qaAssignedAt,
        )} - Qa assigned`}</StyledUpdatedText>
      )}
      {!isNil(qadAt) && !isNil(qadBy) && (
        <StyledUpdatedText>{`${formatDateUk(qadAt)}${
          qadBy ? ` - QA done - ${qadBy.email}` : ''
        } (${latestQadDishCount})`}</StyledUpdatedText>
      )}

      {!isNil(qcAssignedAt) && (
        <StyledUpdatedText>{`${formatDateUk(
          qcAssignedAt,
        )} - Qc assigned`}</StyledUpdatedText>
      )}
      {!isNil(qcdAt) && !isNil(qcdBy) && (
        <StyledUpdatedText>{`${formatDateUk(qcdAt)}${
          qcdBy ? ` - QC done - ${qcdBy.email}` : ''
        } (${latestQcdDishCount})`}</StyledUpdatedText>
      )}

      {!isNil(unknownWordsCuratorAssignedAt) && (
        <StyledUpdatedText>{`${formatDateUk(
          unknownWordsCuratorAssignedAt,
        )} - U.W Curator assigned`}</StyledUpdatedText>
      )}
      {!isNil(unknownWordsCuratedAt) && !isNil(unknownWordsCuratedBy) && (
        <StyledUpdatedText>{`${formatDateUk(unknownWordsCuratedAt)}${
          unknownWordsCuratedBy
            ? ` - U.W Curation done - ${unknownWordsCuratedBy.email}`
            : ''
        } (${latestCuratedUnknownWordCount})`}</StyledUpdatedText>
      )}

      {!isNil(unknownWordsQaAssignedAt) && (
        <StyledUpdatedText>{`${formatDateUk(
          unknownWordsQaAssignedAt,
        )} - U.W Qa assigned`}</StyledUpdatedText>
      )}
      {!isNil(unknownWordsQadAt) && !isNil(unknownWordsQadBy) && (
        <StyledUpdatedText>{`${formatDateUk(unknownWordsQadAt)}${
          unknownWordsQadBy ? ` - U.W Qa done - ${unknownWordsQadBy.email}` : ''
        } (${latestQadUnknownWordCount})`}</StyledUpdatedText>
      )}
    </>
  )
}

MenuCurationTaskTimestamps.propTypes = {
  timestamps: menuCurationTaskTimestampsPropType.isRequired,
}

MenuCurationTaskTimestamps.defaultProps = {}

export default MenuCurationTaskTimestamps
